import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type { ChangeForm, SeoFormValues, SyncFromUrl } from './types'

export const SeoActions = {
  init: createAction<ID>('INIT_SEO_FORM_REQUEST'),
  change: createAction<ChangeForm>('CHANGE_FORM_REQUEST'),
  enableMode: createAction('ENABLE_SEO_MODE'),
  show: createAction<ID>('SHOW_NODE_SEO'),
  syncFromUrl: createAction<SyncFromUrl>('SYNC_SEO_FROM_URL_REQUEST'),
}

export const InternalSeoActions = {
  init: createAction<SeoFormValues>('INIT_SEO_FORM'),
  change: createAction<Partial<SeoFormValues>>('CHANGE_FORM'),
}
